import { atom } from 'jotai';

import { filesGenerateWOPITokenMutationAtom } from '../_graphql/mutations/filesGenerateWOPITokenMutation';
import { filesStartWOPIEditingSessionMutationAtom } from '../_graphql/mutations/filesStartWOPIEditingSessionMutation';

// 🟠🟠🟠 ACTION -> Generate WOPI token
export const $generateWOPIToken = filesGenerateWOPITokenMutationAtom({
  onSuccess: () => {
    // Token generated successfully
    console.log('WOPI token generated');
  },
});

// 🟠🟠🟠 ACTION -> Start WOPI editing session
export const $startWOPIEditingSession =
  filesStartWOPIEditingSessionMutationAtom({
    onSuccess: () => {
      // Editing session started successfully
      console.log('WOPI editing session started');
    },
  });

// 🟡🟡🟡 DERIVED ACTION -> Get WOPI access for file
export const $getWOPIAccess = atom(
  null,
  async (
    get,
    set,
    params: { fileId: string; permission?: 'Read' | 'Write' },
  ) => {
    try {
      const result = await set($generateWOPIToken, {
        fileId: params.fileId,
        permission: params.permission || 'Write',
      });

      if (!result?.filesGenerateWOPIToken?.token) {
        throw new Error('Failed to generate WOPI access token');
      }

      const tokenData = result.filesGenerateWOPIToken.token;
      return {
        token: tokenData.token,
        expiresAt: tokenData.expiresAt,
      };
    } catch (error) {
      console.error('Failed to get WOPI access:', error);
      throw error;
    }
  },
);

// 🟡🟡🟡 DERIVED ACTION -> Start editing session
export const $startEditingSession = atom(
  null,
  async (
    get,
    set,
    params: { fileId: string; permission?: 'Read' | 'Write' },
  ) => {
    try {
      const result = await set($startWOPIEditingSession, {
        fileId: params.fileId,
        permission: params.permission || 'Write',
      });

      if (!result?.filesStartWOPIEditingSession?.session) {
        throw new Error('Failed to start WOPI editing session');
      }

      return result.filesStartWOPIEditingSession.session;
    } catch (error) {
      console.error('Failed to start editing session:', error);
      throw error;
    }
  },
);
